import MotorPrivate from './motor/MotorPrivate.vue';
import MotorCommercial from './motor/MotorCommercial.vue';
import CoverTypeSelection from './motor/Motor_private/components/CoverTypeSelection.vue';
import ProductQuotation from './motor/Motor_private/components/ProductQuotation.vue';
import ViewProductDetails from './motor/Motor_private/components/ViewProductDetails.vue';
import CoverDetails from './motor/Motor_private/components/CoverDetails.vue';
import BenefitsPage from './motor/Motor_private/components/BenefitsPage.vue';
import Quotation from './motor/Motor_private/components/Quotation.vue';
import Help from './motor/Motor_private/components/Help.vue';
import VehicleDetailsForm from './motor/Motor_private/components/VehicleDetailsForm.vue';
import KYCDetailsForm from './motor/Motor_private/components/KYCDetailsForm.vue';
import SummaryPage from './motor/Motor_private/components/SummaryPage.vue';
import Payment from './motor/Motor_private/components/Payment.vue';
import PaymentConfirmation from './motor/Motor_private/components/PaymentConfirmation.vue';
import BasicDetailsLayout from './motor/Motor_private/views/BasicDetailsPage.vue';
import CoverDetailsLayout from './motor/Motor_private/views/CoverDetailsPage.vue';
import PaymentConfirmationLayout from './motor/Motor_private/views/PaymentConfirmationPage.vue';

export const insuranceSubRoutes = [
	{
		path: '/motor',
		name: 'motor-insurance',
		component: MotorPrivate,
		meta: {
			title: 'Motor Private Insurance',
		},
		props: true,
		children: [
			{
				path: 'basic-details',
				name: 'BasicDetails',
				component: BasicDetailsLayout,
				children: [
					{
						path: '',
						redirect: { name: 'CoverTypeSelection' },
					},
					{
						path: 'cover-type',
						name: 'CoverTypeSelection',
						component: CoverTypeSelection,
						meta: {
							title: 'Select Cover Type',
						},
					},
					{
						path: 'product-quotation',
						name: 'ProductQuotation',
						component: ProductQuotation,
						meta: {
							title: 'Product Quotation',
						},
					},
					{
						path: 'view-details',
						name: 'ViewProductDetails',
						component: ViewProductDetails,
						meta: {
							title: 'View Product Details',
						},
					},

					{
						path: 'basic-cover-details',
						name: 'BasicCoverDetails',
						component: CoverDetails,
						meta: {
							title: 'Basic Cover Details',
						},
					},
					{
						path: 'benefits',
						name: 'BenefitsPage',
						component: BenefitsPage,
						meta: {
							title: 'Benefits Selection',
						},
					},
					{
						path: 'quotation',
						name: 'Quotation',
						component: Quotation,
						meta: {
							title: 'Quotation',
						},
					},
				],
			},
			{
				path: 'cover-details',
				name: 'CoverDetails',
				component: CoverDetailsLayout,
				children: [
					{
						path: '',
						redirect: { name: 'VehicleDetailsForm' },
					},
					{
						path: 'vehicle-details',
						name: 'VehicleDetailsForm',
						component: VehicleDetailsForm,
						meta: {
							title: 'Vehicle Details',
						},
					},
					{
						path: 'kyc-details',
						name: 'KYCDetailsForm',
						component: KYCDetailsForm,
						meta: {
							title: 'KYC Details',
						},
					},
				],
			},
			{
				path: 'payment-confirmation',
				name: 'PaymentConfirmation',
				component: PaymentConfirmationLayout,
				children: [
					{
						path: '',
						redirect: { name: 'SummaryPage' },
					},
					{
						path: 'summary',
						name: 'SummaryPage',
						component: SummaryPage,
						meta: {
							title: 'Summary',
						},
					},
					{
						path: 'payment',
						name: 'Payment',
						component: Payment,
						meta: {
							title: 'Payment',
						},
					},
					{
						path: 'confirmation',
						name: 'PaymentConfirmationComponent',
						component: PaymentConfirmation,
						meta: {
							title: 'Payment Confirmation',
						},
					},
				],
			},
		],
	},
	{
		path: 'help',
		name: 'HelpMotor',
		component: Help,
		meta: {
			title: 'Help',
		},
	},
	{
		path: 'view-intermediaries/:id',
		name: 'ViewIntermediary',
		component: () =>
			import('./motor/Motor_private/components/ViewIntermediary.vue'),
		meta: {
			title: 'Intermediaries',
		},
	},
	{
		path: 'view-underwriter/:id',
		name: 'ViewUnderwriter',
		component: () =>
			import('./motor/Motor_private/components/ViewUnderwriter.vue'),
		meta: {
			title: 'Underwriter',
		},
	},
	{
		path: 'review/:id',
		name: 'QuotationPreview',
		component: () =>
			import(`./motor/quotation/client-quotation-preview.vue`),
	},
	{
		path: '/policy/renewal/:policyId',
		name: 'PolicyRenewal',
		component: () => import(`./renewal/PolicyRenewal.vue`),
	},

	// {
	//   path: 'valuation',
	//   name: 'ValuationPage',
	//   component: () => import(`./motor/valuation/valuation.vue`),
	//   meta: { title: 'Valuation' },
	//   props: true
	// },
	{
		path: '/valuation',
		name: 'ValuationRequest',
		component: () => import('./motor/valuation/valuation-request.vue'),
		meta: { title: 'Valuation' },
		props: (route) => ({ request: route.query.request }),
	},

	{
		path: 'details/:qid/:id',
		name: 'QuotationDetails',
		component: () =>
			import(`./motor/quotation/client-quotation-details.vue`),
	},
	{
		path: '/quotation/entity-quotation/:id',
		name: 'DirectQuotation',
		component: () => import(`./motor/quotation/direct-quotation.vue`),
	},
	// {
	//   path: 'kyc/:id',
	//   name: 'QuotationKYC',
	//   component: () => import(`./motor/quotation/kyc-details.vue`)
	// },
	{
		path: 'summary/:id',
		name: 'QuotationSummary',
		component: () => import(`./motor/quotation/quotation-summary.vue`),
	},
	{
		path: '/contactus',
		name: 'ContactUs',
		component: () => import(`../main/contact/contact`),
	},
	{
		path: '/terms',
		name: 'TermsAndConditions',
		component: () => import(`./Terms.vue`),
	},
	{
		path: '/about-us',
		name: 'AboutUs',
		component: () => import(`../main/about/about`),
	},
	{
		path: '/about-claims',
		name: 'AboutClaims',
		component: () => import(`../main/claim/about-claims`),
	},
	{
		path: '/home',
		name: 'Home',
		component: () => import(`./InsuranceFlow`),
	},
	{
		path: '/our-products',
		name: 'ProductList',
		component: () => import(`./ProductList`),
	},
	{
		path: '/',
		name: 'insurance',
		component: () => import(`./InsuranceFlow`),
	},
	{
		path: '/motor-commercial/:productId/:classCode',
		name: 'motor-commercial',
		component: MotorCommercial,
		meta: {
			title: 'Motor Commercial Insurance',
		},
		props: true,
	},
	{
		path: '/theft-insurance/:productId/:classCode',
		name: 'theft-insurance',
		component: MotorPrivate, // TODO: Replace with TheftInsurance component
		meta: {
			title: 'Theft Insurance',
		},
		props: true,
	},
	{
		path: '/aviation-insurance/:productId/:classCode',
		name: 'aviation-insurance',
		component: MotorPrivate, // TODO: Replace with AviationInsurance component
		meta: {
			title: 'Aviation Insurance',
		},
		props: true,
	},
	{
		path: '/fire-domestic/:productId/:classCode',
		name: 'fire-domestic',
		component: MotorPrivate, // TODO: Replace with FireDomestic component
		meta: {
			title: 'Fire Domestic Insurance',
		},
		props: true,
	},
	{
		path: '/marine/:productId/:classCode',
		name: 'marine',
		component: MotorPrivate, // TODO: Replace with Marine component
		meta: {
			title: 'Marine Insurance',
		},
		props: true,
	},
	{
		path: '/medical/:productId/:classCode',
		name: 'medical',
		component: MotorPrivate, // TODO: Replace with Medical component
		meta: {
			title: 'Medical Insurance',
		},
		props: true,
	},
	{
		path: '/engineering-insurance/:productId/:classCode',
		name: 'engineering-insurance',
		component: MotorPrivate, // TODO: Replace with EngineeringInsurance component
		meta: {
			title: 'Engineering Insurance',
		},
		props: true,
	},
	{
		path: '/life-assurance/:productId/:classCode',
		name: 'life-assurance',
		component: MotorPrivate, // TODO: Replace with LifeAssurance component
		meta: {
			title: 'Life Assurance',
		},
		props: true,
	},
	{
		path: '/annuities/:productId/:classCode',
		name: 'annuities',
		component: MotorPrivate, // TODO: Replace with Annuities component
		meta: {
			title: 'Annuities',
		},
		props: true,
	},
	{
		path: '/group-life/:productId/:classCode',
		name: 'group-life',
		component: MotorPrivate, // TODO: Replace with GroupLife component
		meta: {
			title: 'Group Life',
		},
		props: true,
	},
	{
		path: '/unit-link-and-linked-investments/:productId/:classCode',
		name: 'unit-link-and-linked-investments',
		component: MotorPrivate, // TODO: Replace with UnitLinkInvestments component
		meta: {
			title: 'Unit Link and Linked Investments',
		},
		props: true,
	},
	{
		path: '/non-linked-investments/:productId/:classCode',
		name: 'non-linked-investments',
		component: MotorPrivate, // TODO: Replace with NonLinkedInvestments component
		meta: {
			title: 'Non-Linked Investments',
		},
		props: true,
	},
	{
		path: '/group-credit/:productId/:classCode',
		name: 'group-credit',
		component: MotorPrivate, // TODO: Replace with GroupCredit component
		meta: {
			title: 'Group Credit',
		},
		props: true,
	},
	{
		path: '/permanent-health/:productId/:classCode',
		name: 'permanent-health',
		component: MotorPrivate, // TODO: Replace with PermanentHealth component
		meta: {
			title: 'Permanent Health',
		},
		props: true,
	},
	{
		path: '/deposit-administration/:productId/:classCode',
		name: 'deposit-administration',
		component: MotorPrivate, // TODO: Replace with DepositAdministration component
		meta: {
			title: 'Deposit Administration',
		},
		props: true,
	},

	// Flow outside Nexus routes
];
